import { PagingResponse } from '../../interfaces/paging/paging-response.interface';
import { TableDataObject } from '../../interfaces/table-data-object/table-data-object.interface';

export class PagingResponseDataTableObjectModel implements PagingResponse<TableDataObject> {
  content: Array<TableDataObject>;
  pageable: {
    sort: {
      unsorted: boolean;
      sorted: boolean;
      empty: boolean;
    };
    offset: number;
    pageSize: number;
    pageNumber: number;
    paged: boolean;
    unpaged: boolean;
  };
  totalPages: number;
  totalElements: number;
  last: boolean;
  first: boolean;
  sort: {
    sorted: boolean;
    unsorted: boolean;
    empty: boolean;
  };
  numberOfElements: number;
  size: number;
  number: number;
  empty: boolean;

  constructor(
    content?: Array<TableDataObject>,
    pageable?: {
      sort: {
        unsorted: boolean;
        sorted: boolean;
        empty: boolean;
      };
      offset: number;
      pageSize: number;
      pageNumber: number;
      paged: boolean;
      unpaged: boolean;
    },
    totalPages?: number,
    totalElements?: number,
    last?: boolean,
    first?: boolean,
    sort?: {
      sorted: boolean;
      unsorted: boolean;
      empty: boolean;
    },
    numberOfElements?: number,
    size?: number,
    number?: number,
    empty?: boolean
  ) {
    this.content = content ? content : [];
    this.pageable = pageable ? pageable : null;
    this.totalPages = totalPages ? totalPages : 0;
    this.totalElements = totalElements ? totalElements : 0;
    this.last = last ? last : null;
    this.first = first ? first : null;
    this.sort = sort ? sort : null;
    this.numberOfElements = numberOfElements ? numberOfElements : null;
    this.size = size ? size : null;
    this.number = number ? number : null;
    this.empty = empty ? empty : null;
  }
}
